/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import TimeSheetPresenter from './TimeSheetPresenter';
import DTOTimeSheet from './DTOTimeSheet';
import { useAppSelector } from '../../../../infra/hooks';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { defaultDateFormatting } from '../../../../common/helper';

function TimeSheetController() {
  const { t } = useTranslation();

  const [timesheetData, settimesheetData] = useState([]);
  const [getMonth, setGetMonth] = useState();
  const [getYear, setGetYear] = useState();
  const [fromdate, setFromDate] = useState<any>(moment().startOf('month').format('yyyy-MM-DD'));
  const [todate, setToDate] = useState<any>(null);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [page, setPage] = useState<number>(0);

  const isLaoding = useAppSelector(
    (state) => state.getEmpTimeSheetSlice.timeSheetLoader,
  );

  function callBackFunc(data: any) {
    settimesheetData(data);
  }

  function getData(data: any) {
    const _splitData = data.split(' ');
    setGetMonth(_splitData[0]);
    setGetYear(_splitData[1]);
  }

  const handleFromDate = (_fromdate: any) => {
    setFromDate(moment(_fromdate).format(defaultDateFormatting));
  };
  const handleToDate = (_todate: any) => {
    setToDate(moment(_todate).format(defaultDateFormatting));
  };
  return (
    <>
      <DTOTimeSheet
        setEmptimesheetDatas={callBackFunc}
        year={getYear}
        month={getMonth}
        fromdate={fromdate}
        todate={todate}
        setCount={setTotalCount}
        pageSize={pageSize}
        page={page}
      />
      <TimeSheetPresenter
        timesheetData={timesheetData}
        setFilterYearAndMonth={getData}
        isLaoding={isLaoding}
        trans={t}
        fromdate={fromdate}
        todate={todate}
        callFromDateValue={handleFromDate}
        callToDateValue={handleToDate}
        totalCount={totalCount}
        setPageSize={setPageSize}
        pageSize={pageSize}
        setPage={setPage}
        page={page}
      />
    </>
  );
}
export default TimeSheetController;
